/* eslint-disable eqeqeq */
import {action, computed, override, makeObservable} from 'mobx';
import * as fieldTypes from '../../../../constants/FieldTypes';
import * as ItemTypes from '../../../../constants/ItemTypes';
import {hiddenFieldTypes} from '../../../../constants/FieldConsts';
import {Field} from '../../Common/stores/Field';
import {SystemReportCollection} from './SystemReportCollection';

export class SystemReportField extends Field {
    repType;
    mayDesignTitle;
    mayRename;
    mayDesignField;
    isGroup;
    isWWWDocNum;
    designed;
    isDesign;
    isClone;
    changed;
    // font variables
    Background2Blue;
    Background2Green;
    Background2Red;
    BackgroundBlue;
    BackgroundGreen;
    BackgroundRed;
    ForegroundBlue;
    ForegroundGreen;
    ForegroundRed;
    TitleBackgroundBlue;
    TitleBackgroundRed;
    TitleBackgrounddGreen;
    TitleForegroundBlue;
    TitleForegroundGreen;
    TitleForegroundRed;
    col;
    dateformat;
    decimal;
    fontface;
    fontsize;
    halign;
    isbold;
    isitalic;
    isneg;
    isunderline;
    line;
    mayneg;
    nowrap;
    titlecol;
    titlefontface;
    titlefontsize;
    titlehalign;
    titleisbold;
    titleisitalic;
    titleisstrike;
    isstrike;
    titleisunderline;
    titleline;
    titlevalign;
    valign;
    isDocument;
    srvIndex;
    exec;

    constructor(field, parentField) {
        super(field, parentField);
        makeObservable(this);
        this.repType = field.repType;
        this.mayRename = field.mayRename;
        this.mayDesignTitle = field.mayDesignTitle;
        this.mayDesignField = field.mayDesignField;
        this.isGroup = field.isGroup;
        this.exec = field.exec;
        this.isWWWDocNum = field.isWWWDocNum;
        this.designed = field.designed;
        this.isDesign = field.isDesign;
        this.Background2Blue = field.Background2Blue;
        this.Background2Green = field.Background2Green;
        this.Background2Red = field.Background2Red;
        this.BackgroundBlue = field.BackgroundBlue;
        this.BackgroundGreen = field.BackgroundGreen;
        this.BackgroundRed = field.BackgroundRed;
        this.ForegroundBlue = field.ForegroundBlue;
        this.ForegroundGreen = field.ForegroundGreen;
        this.ForegroundRed = field.ForegroundRed;
        this.TitleBackgroundBlue = field.TitleBackgroundBlue;
        this.TitleBackgroundRed = field.TitleBackgroundRed;
        this.TitleBackgrounddGreen = field.TitleBackgrounddGreen;
        this.TitleForegroundBlue = field.TitleForegroundBlue;
        this.TitleForegroundGreen = field.TitleForegroundGreen;
        this.TitleForegroundRed = field.TitleForegroundRed;
        this.col = field.col;
        this.dateformat = field.dateformat;
        this.decimal = field.decimal;
        this.fontface = field.fontface;
        this.fontsize = field.fontsize;
        this.halign = field.halign;
        this.isbold = field.isbold;
        this.isitalic = field.isitalic;
        this.isneg = field.isneg;
        this.isunderline = field.isunderline;
        this.isstrike = field.isstrike;
        this.line = field.line;
        this.mayneg = field.mayneg;
        this.nowrap = field.nowrap;
        this.titlecol = field.titlecol;
        this.titlefontface = field.titlefontface;
        this.titlefontsize = field.titlefontsize;
        this.titlehalign = field.titlehalign;
        this.titleisbold = field.titleisbold;
        this.titleisitalic = field.titleisitalic;
        this.titleisstrike = field.titleisstrike;
        this.titleisunderline = field.titleisunderline;
        this.titleline = field.titleline;
        this.titlevalign = field.titlevalign;
        this.valign = field.valign;
        this.isDocument = field.isDocument;
        this.srvIndex = field.index;
        this.changed = false;
        this.collection = new SystemReportCollection(parentField.collection);
    }

    setCollection(field, cloned?) {
        if (cloned) {
            field.collection.fields &&
                this.collection.insertFields(this, field.collection.fields, cloned);
        } else {
            field.fields && this.collection.insertFields(this, field.fields, cloned);
        }
    }

    @override get hidden() {
        return this.hiddenStatus !== hiddenFieldTypes.SHOWN && this.hiddenStatus;
    }

    toggleHide(value?) {
        let dest;
        const hidden =
            this.hiddenStatus == hiddenFieldTypes.HIDDEN ||
            this.hiddenStatus == hiddenFieldTypes.HIDDEN_BOTH ||
            this.hiddenStatus == hiddenFieldTypes.HIDDEN_IN_PACKAGE;

        if (
            this.hiddenStatus === hiddenFieldTypes.HIDDEN_BOTH ||
            this.hiddenStatus === hiddenFieldTypes.HIDDEN_IN_PACKAGE
        ) {
            return;
        }

        if (
            value != hiddenFieldTypes.SHOWN &&
            (hidden === false || value == hiddenFieldTypes.HIDDEN)
        ) {
            dest = this.parentCollection.firstHiddenIdx - 1;
            this.setHide(hiddenFieldTypes.HIDDEN);
        } else {
            dest = this.parentCollection.firstHiddenIdx;
            if (this.repType === ItemTypes.Field && this.parentField.isHiddenImage) {
                this.parentField.setHide(hiddenFieldTypes.SHOWN);
            }
            this.setHide(hiddenFieldTypes.SHOWN);
        }
        this.changed = true;
        if (this.repType == ItemTypes.Field) {
            this.parentCollection.moveField(this, dest);
            this.screen.setActive(null);
        } else if (this.repType === ItemTypes.Report) {
            this.collection.fields.forEach(f => {
                f.setHide(this.hiddenStatus);
            });
        }
    }

    @action deleteDesignField() {
        const designDelete = (window as any).designDelete;
        designDelete(this.srvIndex + '');
    }

    @action restoreDesignField() {
        const designRestore = (window as any).designRestore;
        designRestore(this.srvIndex + '');
    }

    @action setData(row, dataTables) {
        const setDataRowItemJs = (window as any).setDataRowItemJs;
        const setChildDataRowItemJS = (window as any).setChildDataRowItemJS;

        setDataRowItemJs(row, 'pos', this.pos);
        setDataRowItemJs(row, 'title', this.title);
        setDataRowItemJs(row, 'hidden', this.hiddenStatus + '');
        setDataRowItemJs(row, 'dateformat', this.dateformat);
        setDataRowItemJs(row, 'type', this.repType);
        setDataRowItemJs(row, 'index', this.srvIndex);
        setDataRowItemJs(row, 'mayrename', this.mayRename ? '1' : '0');
        setDataRowItemJs(row, 'maydesigntitle', this.mayDesignTitle ? '1' : '0');
        setDataRowItemJs(row, 'maydesignfield', this.mayDesignField ? '1' : '0');
        setDataRowItemJs(row, 'isgroup', this.isGroup ? '1' : '0');
        setDataRowItemJs(row, 'exec', this.exec);
        setDataRowItemJs(row, 'isdesign', this.isDesign ? '1' : '0');
        setDataRowItemJs(row, 'changed', this.changed ? '1' : '0');

        if (this.repType === ItemTypes.Report) {
            setDataRowItemJs(row, 'iswwwdocnum', this.isWWWDocNum ? '1' : '0');
        } else if (this.repType === ItemTypes.Field) {
            setDataRowItemJs(row, 'fontface', this.fontface);
            setDataRowItemJs(row, 'fontsize', this.fontsize);
            setDataRowItemJs(row, 'titlefontface', this.titlefontface);
            setDataRowItemJs(row, 'titlefontsize', this.titlefontsize);

            if (this.nowrap === true) {
                setDataRowItemJs(row, 'nowrap', 'W');
            } else if (this.nowrap === false) {
                setDataRowItemJs(row, 'nowrap', null);
            }

            setDataRowItemJs(row, 'decimal', this.decimal + '');
            setDataRowItemJs(row, 'IsNeg', this.isneg ? '1' : '0');

            const tables = dataTables[Object.keys(dataTables)[0]];
            const backgroundColor = tables._BackgroundColor;
            const ForegroundColor = tables._ForegroundColor;
            const BackgroundColor2 = tables._BackgroundColor2;
            const TitleForegroundColor = tables._TitleForegroundColor;
            const TitleBackgroundColor = tables._TitleBackgroundColor;

            const backGroundColors = `${this.BackgroundRed},${this.BackgroundGreen},${this.BackgroundBlue}`;
            const foreGroundColors = `${this.ForegroundRed},${this.ForegroundGreen},${this.ForegroundBlue}`;
            const backGroundColors2 = `${this.Background2Red},${this.Background2Green},${this.Background2Blue}`;
            const titleBackgroundColors = `${this.TitleBackgroundRed},${this.TitleBackgrounddGreen},${this.TitleBackgroundBlue}`;
            const titleForegroundColors = `${this.TitleForegroundRed},${this.TitleForegroundGreen},${this.TitleForegroundBlue}`;

            setChildDataRowItemJS(row, backgroundColor, backGroundColors);
            setChildDataRowItemJS(row, ForegroundColor, foreGroundColors);
            setChildDataRowItemJS(row, BackgroundColor2, backGroundColors2);

            setChildDataRowItemJS(row, TitleBackgroundColor, titleBackgroundColors);
            setChildDataRowItemJS(row, TitleForegroundColor, titleForegroundColors);

            setDataRowItemJs(row, 'valign', this.valign);
            setDataRowItemJs(row, 'halign', this.halign);

            setDataRowItemJs(row, 'titlevalign', this.titlevalign);
            setDataRowItemJs(row, 'titlehalign', this.titlehalign);

            setDataRowItemJs(row, 'isbold', this.isbold ? '1' : '0');
            setDataRowItemJs(row, 'isitalic', this.isitalic ? '1' : '0');
            setDataRowItemJs(row, 'isstrike', this.isstrike ? '1' : '0');
            setDataRowItemJs(row, 'isunderline', this.isunderline ? '1' : '0');

            setDataRowItemJs(row, 'titleisbold', this.titleisbold ? '1' : '0');
            setDataRowItemJs(row, 'titleisitalic', this.titleisitalic ? '1' : '0');
            setDataRowItemJs(row, 'titleisstrike', this.titleisstrike ? '1' : '0');
            setDataRowItemJs(row, 'titleisunderline', this.titleisunderline ? '1' : '0');
        }
    }

    @action setDesignAttributes(designAttributes) {
        this.fontface = designAttributes.fontface;
        this.fontsize = designAttributes.fontsize;

        this.nowrap = designAttributes.nowrap;
        this.decimal = designAttributes.decimal;
        this.isneg = designAttributes.isneg;

        this.titlefontface = designAttributes.titlefontface;
        this.titlefontsize = designAttributes.titlefontsize;

        this.BackgroundBlue = designAttributes.BackgroundBlue;
        this.BackgroundGreen = designAttributes.BackgroundGreen;
        this.BackgroundRed = designAttributes.BackgroundRed;

        this.Background2Blue = designAttributes.Background2Blue;
        this.Background2Green = designAttributes.Background2Green;
        this.Background2Red = designAttributes.Background2Red;

        this.ForegroundBlue = designAttributes.ForegroundBlue;
        this.ForegroundGreen = designAttributes.ForegroundGreen;
        this.ForegroundRed = designAttributes.ForegroundRed;

        this.TitleBackgroundBlue = designAttributes.TitleBackgroundBlue;
        this.TitleBackgrounddGreen = designAttributes.TitleBackgrounddGreen;
        this.TitleBackgroundRed = designAttributes.TitleBackgroundRed;

        this.TitleForegroundBlue = designAttributes.TitleForegroundBlue;
        this.TitleForegroundGreen = designAttributes.TitleForegroundGreen;
        this.TitleForegroundRed = designAttributes.TitleForegroundRed;

        this.valign = designAttributes.valign;
        this.halign = designAttributes.halign;

        this.titlevalign = designAttributes.titlevalign;
        this.titlehalign = designAttributes.titlehalign;

        this.isbold = designAttributes.isbold;
        this.isitalic = designAttributes.isitalic;
        this.isstrike = designAttributes.isstrike;
        this.isunderline = designAttributes.isunderline;

        this.titleisbold = designAttributes.titleisbold;
        this.titleisitalic = designAttributes.titleisitalic;
        this.titleisstrike = designAttributes.titleisstrike;
        this.titleisunderline = designAttributes.titleisunderline;

        this.dateformat = designAttributes.dateformat;

        this.changed = true;
        if (this.parentField) {
            this.parentField.changed = true;
        }
    }

    @override setChanging(value) {
        this.isChanging = value;
        this.changed = true;
    }

    @override setTitle(title) {
        this.title = title;
        this.changed = true;
    }

    setMoved(value) {
        this.moved = value;
        this.changed = true;
    }

    setMovedDown(value) {
        this.movedDown = value;
        this.changed = true;
    }

    setMovedUp(value) {
        this.movedUp = value;
        this.changed = true;
    }

    @computed get mayFieldRename() {
        if (this.repType === ItemTypes.Format) {
            if (this.pos > ItemTypes.EshbelPos && this.pos !== 0 && !this.isClone) {
                return false;
            }
            return true;
        } else if (this.pos === ItemTypes.Report) {
            return false;
        } else if (this.mayRename || this.parentField.isWWWDocNum) {
            return true;
        }
        return false;
    }

    @computed get mayFieldDelete() {
        if (this.repType !== ItemTypes.Format) {
            return false;
        }
        return this.pos <= ItemTypes.EshbelPos || this.pos === 0 || this.isClone;
    }

    @computed get isHiddenImage() {
        // Report Field
        if (this.repType === ItemTypes.Report) {
            const childrensNum = this.collection.fields.length;
            const hiddenCount = this.collection.fields.filter(
                field => field.hiddenStatus == hiddenFieldTypes.HIDDEN
            ).length;

            if (childrensNum === hiddenCount) {
                return true;
            }
        } else if (this.repType === ItemTypes.Field) {
            if (this.parentField.isHiddenImage) {
                return true;
            }
        }

        return (
            this.hiddenStatus == hiddenFieldTypes.HIDDEN ||
            this.hiddenStatus == hiddenFieldTypes.HIDDEN_TMP ||
            this.hiddenStatus == hiddenFieldTypes.HIDDEN_BOTH ||
            this.hiddenStatus == hiddenFieldTypes.HIDDEN_IN_PACKAGE
        );
    }

    @override get isSelectable() {
        return !this.isChanging && !this.isHiddenImage;
    }

    @computed get mayFieldShow() {
        return Boolean(this.repType === ItemTypes.Field && this.parentField.isWWWDocNum);
    }

    @computed get isMovable() {
        return this.parentField !== null && this.repType === ItemTypes.Field;
    }

    @override get needed() {
        if (this.repType !== fieldTypes.TAB) {
            return this.fieldNeeded;
        } else {
            // if it's a tab, it's needed when there're needed fields inside it
            return this.collection.fields.findIndex(field => field.needed === true) >= 0;
        }
    }

    @computed get showDesignField() {
        if (
            this.repType !== ItemTypes.Field ||
            (this.repType === ItemTypes.Field && this.parentField.isWWWDocNum && this.pos == 20)
        ) {
            return false;
        }
        return this.mayDesignField;
    }

    @computed get showDesignTitle() {
        if (this.repType !== ItemTypes.Field) {
            return false;
        }
        return this.mayDesignTitle;
    }

    @computed get isWrap() {
        return this.nowrap == '0' || this.nowrap == '87';
    }

    @computed get mayRestore() {
        return this.repType === ItemTypes.Format && !this.isClone;
    }

    get doesTitleNeedChecks() {
        return this.repType !== ItemTypes.Field;
    }
}
/* eslint-enable eqeqeq */
